<template>
  <div class="newsletterDialog">
    <v-dialog v-model="dialog" max-width="600px" persistent :scrollable="true">
      <v-card class="newsletterCard">
        <v-icon
            :size="70"
            class="successIcon"
        >check_circle_outline</v-icon>
        <v-card-title><h3 class="title">{{ $t('NEWSLETTER_CONSENT_TITLE') }}</h3></v-card-title>
        <v-card-text class="text">
          <p class="body-1 newsletterText center" v-html="$t('NEWSLETTER_CONSENT_TEXT')"></p>
          <v-form class="newsletterForm" v-model="formValid">
            <v-row wrap>
              <v-col cols="12">
                <v-text-field v-model="email" :label="$t('NEWSLETTER_CONSENT_EMAIL')"
                              type="email" autocomplete="email" autocapitalize="none" :spellcheck="false"
                              required :rules="[globalRules.present, globalRules.email]"/>
              </v-col>
            </v-row>
          </v-form>
          <p class="caption grey--text text--darken-1 text-center" v-html="$t('NEWSLETTER_CONSENT_PRIVACY_POLICY')"></p>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false">{{ $t('NEWSLETTER_CONSENT_BUTTON_DISMISS') }}</v-btn>
          <v-spacer/>
          <v-btn color="primary" :disabled="!formValid" @click="submit">
            {{ $t('NEWSLETTER_CONSENT_BUTTON_SUBMIT') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {CustomerApi} from "@swagger";

@Component({
  components: {}
})
export default class NewsletterDialog extends BasicComponent {

  formValid: boolean = false;
  email: string = "";
  submitted: boolean = false;

  created() {

  }

  submit() {
    if (!this.formValid) {
      return;
    }
    this.submitted = true;
    this.trackEvent("Newsletter", "Akzeptiert");
    new CustomerApi(this.apiConfiguration).registerCustomer({
      email: this.email.trim()
    }).then(() => {
      this.dialog = false;
    })
  }

  get dialog() {
    return this.$store.getters.newsletterDialogOpen;
  }

  set dialog(value) {
    if (! value && !this.submitted) {
      this.trackEvent("Newsletter", "Abgelehnt")
    }
    this.$store.commit("setNewsletterDialogOpen", value);
  }

}

</script>
<style lang="scss" scoped>
@use "../stylesheets/Variables.scss" as *;


.successIcon {
  margin-top: 20px;
  color: $shop-newsletter-success;
  align-self: center;
  flex: 0 0 auto;
  width: 70px;
}

.title {
  font-weight: 500;
  font-size: 26px !important;
  text-align: center;
  width: 100%;
}

.newsletterCard {
  padding: 10px;

  .newsletterText {
    font-size: 15px !important
  }
}

.newsletterForm {
  .flex {
    &:not(:first-of-type) {
      padding-left: 5px;
    }

    &:not(:last-of-type) {
      padding-right: 5px;
    }
  }
}

.text {
  line-height: 1.7;
}

.center {
  text-align: center;
}

</style>
<style lang="scss">
.v-overlay {
  opacity: 0.3;
}
</style>
